import { crud } from '@/api/schoolclasslevels';

const state = {};

const getters = {};

const actions = {
	getSchoolClassLevels() {
		return crud.all();
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
